import { render } from "./BillingInfoForm.vue?vue&type=template&id=5a0c8227"
import script from "./BillingInfoForm.vue?vue&type=script&lang=js"
export * from "./BillingInfoForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__